import { Component, Input, HostListener, OnChanges, SimpleChanges, OnDestroy } from '@angular/core';
import { WaitLoadingService, LoadingInfo } from './wait-loading.service';
import { Observable, Subscription } from 'rxjs';
import { BaseComponent } from '../baseComponent/base.component';

@Component({
  selector: 'wait-component',
  templateUrl: 'wait.template.html'
})
export class WaitComponent extends BaseComponent implements OnDestroy {

  @Input()
  maxView = true;

  public showCancel = false;
  public loadingMessage: string;
  public show = false;


  constructor(private waitService: WaitLoadingService) {
    super();
    this.subscribe(waitService.getLoadingObservable(),
      (loadingInfo: LoadingInfo) => {
        if (loadingInfo) {
          this.loadingMessage = loadingInfo.loadingMsg;
          this.show = loadingInfo.loading;
          this.showCancel = loadingInfo.showCancelButton;
        }

      });
  }

  public getCssClass(): string {
    return this.maxView ? 'max-view' : undefined;
  }

  @HostListener('document:keydown.escape', ['$event'])
  public close() {
    this.waitService.cancelWaiting();
    this.waitService.escapePressesd();
  }
}
